import 'css-chunksrc/client/pages/workloadPage/table/projectsDetail/projectRow/cell/styles.scss';export default {
  "cell": "_cell_n2gge_1",
  "failed": "_failed_n2gge_15",
  "value": "_value_n2gge_19"
};